import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Button as DSButton } from '@hvcgroep/design-system';
import { Props as DSProps } from '@hvcgroep/design-system/dist/components/Button/index';
import { CoreLink } from '@uncinc/react-drupal-core';

const Button = React.forwardRef<HTMLButtonElement, DSProps>((props, ref) => {
  const {
    children,
  } = props;

  return (
    <DSButton
      {...props}
      CustomLinkComponent={CoreLink}
      ref={ref}
    >
      {children}
    </DSButton>
  );
});

export default Button;
